import React from 'react';
import './SocialIcons.css';

const SocialIcons = ({ social, hideEmail = false, compact = false }) => {
  if (!social || Object.keys(social).length === 0) {
    return null;
  }

  const handleClick = (type, value) => {
    if (type === 'telegram') {
      // Открываем Telegram
      window.open(`https://t.me/${value.replace('@', '')}`, '_blank');
    } else if (type === 'max') {
      window.open(value, '_blank');
    } else if (type === 'email') {
      window.open(`mailto:${value}`);
    }
  };

  return (
    <div className={`social-icons ${compact ? 'social-icons-compact' : ''}`}>
      {social.telegram && (
        <button
          className="social-icon telegram"
          onClick={() => handleClick('telegram', social.telegram)}
          title={`Telegram: ${social.telegram}`}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.18-.357.295-.6.295-.002 0-.003 0-.005 0l.213-3.054 5.56-5.022c.24-.213-.054-.334-.373-.121l-6.869 4.326-2.96-.924c-.64-.203-.658-.64.135-.954l11.566-4.458c.538-.196 1.006.128.832.941z"/>
          </svg>
        </button>
      )}
      {social.max && (
        <button
          className="social-icon max"
          onClick={() => handleClick('max', social.max)}
          title={`Max: ${social.max}`}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 1000 1000">
            <defs><linearGradient id="b"><stop offset="0" stop-color="#00f"/><stop offset="1" stop-opacity="0"/></linearGradient><linearGradient id="a"><stop offset="0" stop-color="#4cf"/><stop offset=".662" stop-color="#53e"/><stop offset="1" stop-color="#93d"/></linearGradient><linearGradient id="c" x1="117.847" x2="1000" y1="760.536" y2="500" gradientUnits="userSpaceOnUse" href="#a"/><radialGradient id="d" cx="-87.392" cy="1166.116" r="500" fx="-87.392" fy="1166.116" gradientTransform="rotate(51.356 1551.478 559.3)scale(2.42703433 1)" gradientUnits="userSpaceOnUse" href="#b"/></defs><rect width="1000" height="1000" fill="url(#c)" ry="249.681"/><rect width="1000" height="1000" fill="url(#d)" ry="249.681"/>
            <path fill="#fff" fill-rule="evenodd" d="M508.211 878.328c-75.007 0-109.864-10.95-170.453-54.75-38.325 49.275-159.686 87.783-164.979 21.9 0-49.456-10.95-91.248-23.36-136.873-14.782-56.21-31.572-118.807-31.572-209.508 0-216.626 177.754-379.597 388.357-379.597 210.785 0 375.947 171.001 375.947 381.604.707 207.346-166.595 376.118-373.94 377.224m3.103-571.585c-102.564-5.292-182.499 65.7-200.201 177.024-14.6 92.162 11.315 204.398 33.397 210.238 10.585 2.555 37.23-18.98 53.837-35.587a189.8 189.8 0 0 0 92.71 33.032c106.273 5.112 197.08-75.794 204.215-181.95 4.154-106.382-77.67-196.486-183.958-202.574Z" clip-rule="evenodd"/>
          </svg>

        </button>
      )}
      {social.email && !hideEmail && (
        <button
          className="social-icon email"
          onClick={() => handleClick('email', social.email)}
          title={`Email: ${social.email}`}
        >
          <svg xmlns="http://www.w3.org/2000/svg" aria-label="Mail" role="img" width="16" height="16" viewBox="0 0 512 512"><rect width="512" height="512" rx="15%" fill="#328cff"/>
            <path d="m250 186c-46 0-69 35-69 74 0 44 29 72 68 72 43 0 73-32 73-75 0-44-34-71-72-71zm-1-37c30 0 57 13 77 33 0-22 35-22 35 1v150c-1 10 10 16 16 9 25-25 54-128-14-187-64-56-149-47-195-15-48 33-79 107-49 175 33 76 126 99 182 76 28-12 41 26 12 39-45 19-168 17-225-82-38-68-36-185 67-248 78-46 182-33 244 32 66 69 62 197-2 246-28 23-71 1-71-32v-11c-20 20-47 32-77 32-57 0-108-51-108-108 0-58 51-110 108-110" fill="#fff"/>
          </svg>
        </button>
      )}
    </div>
  );
};

export default SocialIcons;